/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// Internal imports
import ExpulsionStage from 'linced-app/enums/expulsion-stage';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { defaultTinyMCEConfig } from '@linc-technologies/linced-common/utils/tinymce';
import { action } from '@ember/object';

export default class ExpulsionEdit extends Component {
  ExpulsionStage = ExpulsionStage;

  // Services
  @service
  behaviourDates;

  @service
  dates;

  @service
  expulsions;

  @service
  store;

  @service
  toaster;

  @service
  uppy;

  editorOptions = Object.freeze(defaultTinyMCEConfig());
  close = null;
  expulsion = null;
  principal = null;
  save = null;
  @tracked
  saveInProgress = false;
  suspensionLetterPage = null;
  suspensionPostPage = null;
  @tracked
  teachers = [];

  init() {
    super.init(...arguments);

    if (isEmpty(this.get('expulsion.caregivers'))) {
      // Plain array, not A(): caregivers is a @hasMany relationship, and
      // Ember Data's hasMany setter never stores the passed-in array
      // itself - it spreads its items into a splice() call on the real
      // ManyArray, so the wrapper type of the input is irrelevant
      // (verified against the installed ember-data/model source).
      this.expulsion.set('caregivers', []);
    }

    this.teachers = this.store
      .peekAll('person')
      .filter((person) => person.type === PersonType.STAFF);

    this.expulsions.initialise(
      this.expulsion,
      this.principal,
      this.suspensionLetterPage,
      this.suspensionPostPage,
    );
  }

  @action
  removeSelectedPerson(prop) {
    this.expulsion.set(prop, null);
  }

  @action
  async addCaregiver(person) {
    // caregivers is an async hasMany: edit the loaded ManyArray, not the
    // PromiseManyArray, which has no push/splice.
    (await this.expulsion.caregivers).push(person);
  }

  @action
  async removeCaregiver(person) {
    let caregivers = await this.expulsion.caregivers;
    let index = caregivers.indexOf(person);
    if (index !== -1) {
      caregivers.splice(index, 1);
    }
  }

  @action
  addAttachments() {
    this.uppy.addFiles();
  }

  @action
  removeAttachment(attachment) {
    this.expulsions.removeAttachment(attachment);
  }

  @action
  async saveAndClose() {
    this.saveInProgress = true;

    try {
      await this.expulsions.expulsionSavePipeline();
    } catch (err) {
      this.toaster.error('Failed to save expulsion/letters: ' + err);
    }

    this.close();
  }

  @action
  validateAndSetDate(validate, prop, date) {
    this.behaviourDates.validateAndSetDate(
      this.expulsion,
      validate,
      prop,
      date,
    );
  }
}
